import { FormGroup, ValidationErrors } from '@angular/forms';

export const passwordMatchValidator = (formGroup: FormGroup): ValidationErrors | null => {
  const passwordControl = formGroup.get('password');
  const confirmPasswordControl = formGroup.get('confirmPassword');

  if (!passwordControl || !confirmPasswordControl) {
    return null;
  }

  const password = passwordControl.value;
  const confirmPassword = confirmPasswordControl.value;

  const requiredError = confirmPasswordControl.hasError('required');

  let errors: ValidationErrors | null = requiredError ? { required: true } : null;

  if (password === confirmPassword) {
    confirmPasswordControl.setErrors(errors);
    return null;
  } else {
    errors = errors
      ? errors
      : {
          ...{
            passwordsUnequal: true,
          },
        };

    confirmPasswordControl.setErrors(errors);
    return { passwordsUnequal: true };
  }
};
